// ** Third Party Components
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
// ** Reactstrap Imports
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { handleLang } from "@store/layout/layout";
import { useDispatch } from "react-redux";
import { useRTL } from "@hooks/useRTL";
import { useEffect } from "react";

const IntlDropdown = () => {
  // ** Hooks
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();

  const setLang = (type) => {
    dispatch(handleLang(type));
  };
  // ** Vars
  const langObj = {
    en: "English",
    fr: "French",
    ar: "Arabic",
  };

  var item = window.localStorage.getItem("lang");
  const item1 = item ? item.substring(1, item.length - 1) : "en";
  // ** Function to switch Language
  const handleLangUpdate = (e, lang) => {
    e.preventDefault();
    i18n.changeLanguage(item1);
    setLang(lang);
  };
  const [isRtl, setIsRtl] = useRTL();
  useEffect(() => {
    i18n.changeLanguage(item1);
    if (item1 == "ar") {
      setIsRtl(true);
    } else {
      setIsRtl(false);
    }
  }, [item1]);

  return (
    <UncontrolledDropdown
      href="/"
      tag="li"
      className="dropdown-language nav-item"
    >
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link"
        onClick={(e) => e.preventDefault()}
      >
        <ReactCountryFlag
          svg
          className="country-flag flag-icon"
          countryCode={item1 === "en" ? "us" : item1 === "ar" ? "tn" : item1}
        />
        <span className="selected-language">{t(langObj[i18n.language])}</span>
      </DropdownToggle>
      <DropdownMenu className="mt-0" end>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "en")}
        >
          <ReactCountryFlag className="country-flag" countryCode="us" svg />
          <span className="ms-1">{t("English")}</span>
        </DropdownItem>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "fr")}
        >
          <ReactCountryFlag className="country-flag" countryCode="fr" svg />
          <span className="ms-1">{t("French")}</span>
        </DropdownItem>
        <DropdownItem
          href="/"
          tag="a"
          onClick={(e) => handleLangUpdate(e, "ar")}
        >
          <ReactCountryFlag className="country-flag" countryCode="tn" svg />
          <span className="ms-1">{t("Arabic")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default IntlDropdown;
